import { useSelector } from "react-redux";
import { useMemo } from "react";

export default function useIsGoodwe60kIv(SelInverter) {
  const Iv_list = useSelector((state) => state.Iv_list || {});

  const isGoodwe60k = useMemo(() => {
    if (!Iv_list.seq || !Array.isArray(Iv_list.seq)) return false;
    const index = Iv_list.seq.findIndex((seq) => seq === SelInverter);
    const protocol = Iv_list.iv_protocol?.[index] || "";
    return protocol.toUpperCase() === "GOODWE_60K";
  }, [Iv_list, SelInverter]);

  return isGoodwe60k;
}
